/**
 * Логика дверей: элемент по id, тип поставленной двери и размеры проёма по умолчанию.
 */
import { doorSection } from "./catalog";
import type { DoorCatalogItem } from "./types";

export const doorItemById = (id: string): DoorCatalogItem | null =>
	doorSection.items.find((item) => item.id === id) ?? null;

/** Тип поставленной двери; у старых проектов типа нет — обычная, первый элемент каталога. */
export const doorItemOf = (id: string | undefined): DoorCatalogItem =>
	(id ? doorItemById(id) : null) ?? doorSection.items[0];

/** Размеры проёма, с которыми ставится новая дверь: первый элемент каталога, порог на полу. */
export const defaultDoorPreset = (): {
	item: string;
	width: number;
	height: number;
	sill: number;
} => {
	const item = doorSection.items[0];
	return { item: item.id, width: item.width, height: item.height, sill: 0 };
};
